<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="pa-icon-gradient"
        x1="0"
        y1="16"
        x2="16"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0%" stop-color="#322615" />
        <stop offset="100%" stop-color="#F6DA94" />
      </linearGradient>
    </defs>
    <rect
      width="16"
      height="16"
      rx="3.5"
      fill="url(#pa-icon-gradient)"
    />
    <g transform="translate(2, 2) scale(0.75)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.378 0.0115349C12.8013 0.0269281 13.8772 0.752917 14.2857 2.03199C14.6061 3.03559 14.4003 3.97852 13.6975 4.8017C11.3374 7.56533 8.97791 10.329 6.61653 13.0915C6.18341 13.5979 5.75049 14.1044 5.30398 14.5997C4.20865 15.8154 2.357 16.0078 1.13744 15.0409C-0.183842 13.9934 -0.386358 12.2229 0.700235 10.9273C2.02263 9.35041 3.37348 7.79533 4.70667 6.22665C4.787 6.13214 4.8201 6.00059 4.87534 5.88621C4.73679 5.84468 4.59974 5.77309 4.45952 5.76682C3.97991 5.74516 3.49864 5.72673 3.01922 5.74266C1.38756 5.79653 0.027414 4.5606 0.00956133 2.91925C-0.00810535 1.29311 1.27431 0.0467962 3.00992 0.0135038C4.41972 -0.0133449 5.83027 0.00813404 7.24044 0.00813404C8.61956 0.00813404 9.99904 -0.00350039 11.378 0.0115349Z"
        fill="white"
      />
      <path
        opacity="0.5"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.76353 13.2395C9.79708 12.7964 9.93724 12.3916 10.2261 12.0458C11.0434 11.0679 11.551 10.4585 12.4091 9.55192C12.7257 9.21744 12.9759 9.37898 13.0868 9.63844C13.5894 10.8143 13.8641 11.5286 14.3055 12.7388C14.808 14.1167 13.6913 15.611 12.1755 15.643C12.0303 15.646 11.885 15.6381 11.7398 15.6352C10.5263 15.4527 9.67382 14.421 9.76353 13.2395Z"
        fill="white"
      />
    </g>
  </svg>
</template>
